package br.com.htms.inspeccaocampo.util

import br.com.htms.inspeccaocampo.platform.ImageSize

/** Lê dimensões de JPEG/PNG sem decodificar o bitmap completo. */
object ImageHeaders {
    fun size(bytes: ByteArray): ImageSize? {
        if (bytes.size < 10) return null
        if (bytes[0] == 0xFF.toByte() && bytes[1] == 0xD8.toByte()) return jpegSize(bytes)
        if (bytes[0] == 0x89.toByte() && bytes[1] == 'P'.code.toByte()) return pngSize(bytes)
        return null
    }

    private fun pngSize(bytes: ByteArray): ImageSize? {
        if (bytes.size < 24) return null
        val w = readIntBe(bytes, 16)
        val h = readIntBe(bytes, 20)
        return if (w > 0 && h > 0) ImageSize(w, h) else null
    }

    private fun jpegSize(bytes: ByteArray): ImageSize? {
        var i = 2
        while (i + 9 < bytes.size) {
            if (bytes[i] != 0xFF.toByte()) {
                i++
                continue
            }
            val marker = bytes[i + 1].toInt() and 0xff
            if (marker == 0xD9 || marker == 0xDA) break
            if (marker in 0xC0..0xC3 || marker in 0xC5..0xC7 || marker in 0xC9..0xCB || marker in 0xCD..0xCF) {
                val h = ((bytes[i + 5].toInt() and 0xff) shl 8) or (bytes[i + 6].toInt() and 0xff)
                val w = ((bytes[i + 7].toInt() and 0xff) shl 8) or (bytes[i + 8].toInt() and 0xff)
                return ImageSize(w, h)
            }
            val len = ((bytes[i + 2].toInt() and 0xff) shl 8) or (bytes[i + 3].toInt() and 0xff)
            i += 2 + len
        }
        return null
    }

    private fun readIntBe(bytes: ByteArray, offset: Int): Int =
        ((bytes[offset].toInt() and 0xff) shl 24) or
            ((bytes[offset + 1].toInt() and 0xff) shl 16) or
            ((bytes[offset + 2].toInt() and 0xff) shl 8) or
            (bytes[offset + 3].toInt() and 0xff)
}
